import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { gridSize } from '@atlaskit/theme/constants';
import { h200 } from '@atlaskit/theme/typography';
import { R400 } from '@atlaskit/theme/colors';
import { multiply } from '@atlaskit/theme/math';
/**
 * Provide a styled container for field components
 */
var FieldWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", "px;\n"], ["\n  margin-top: ", "px;\n"])), gridSize);
/**
 * Provide a styled Label for field components
 */
export var Label = styled.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", " display: inline-block;\n  margin-bottom: ", "px;\n  margin-top: 0;\n"], ["\n  ", " display: inline-block;\n  margin-bottom: ", "px;\n  margin-top: 0;\n"])), h200(), multiply(gridSize, 0.5));
export var RequiredIndicator = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  padding-left: ", "px;\n"], ["\n  color: ", ";\n  padding-left: ", "px;\n"])), R400, multiply(gridSize, 0.25));
export default FieldWrapper;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Field.js.map